<div *ngIf="loading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div class="mb-5 rounded-md border border-[#ebedf2] bg-white p-4 dark:border-[#191e3a] dark:bg-[#0e1726]">
  <div class="mb-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <h6 class="text-lg font-bold">{{ "office-branch.tax_categories" | translate }}</h6>
    <div>
      <button type="button" (click)="openModalForCreate()" class="btn btn-primary flex items-center gap-2">
        <icon-plus class="h-5 w-5" />
        {{ "office-branch.add_new_tax_category" | translate }}
      </button>
    </div>
  </div>

  <div class="rounded-lg bg-white dark:bg-[#0e1726]" *ngIf="categories">
    <ng-datatable
      #datatable
      [rows]="categories"
      [stickyHeader]="true"
      [height]="'670px'"
      [columns]="cols"
      [sortable]="true"
      [pagination]="false"
      [loading]="loading"
      [isServerMode]="true"
      [totalRows]="categories.length"
      skin="whitespace-nowrap table-hover"
      [paginationInfo]="'paginationInfoLabel' | translate"
      [noDataContent]="'empty_tables' | translate"
    >
      <ng-template slot="title" let-value="data">
        <span class="font-semibold">{{ value.title }}</span>
      </ng-template>
      <ng-template slot="taxLabel" let-value="data">
        <span>{{ value.taxLabel }}</span>
      </ng-template>
      <ng-template slot="taxType" let-value="data">
        <span>{{ value.taxType }}</span>
      </ng-template>
      <ng-template slot="code" let-value="data">
        <span>{{ value.code }}</span>
      </ng-template>
      <ng-template slot="percentage" let-value="data">
        <span>{{ value.percentage }}%</span>
      </ng-template>
      <ng-template slot="desicionNumber" let-value="data">
        <span>{{ value.desicionNumber }}</span>
      </ng-template>
      <ng-template slot="actions" let-value="data">
        <div class="flex w-max items-center justify-between">
          <div hlMenu class="dropdown">
            <a hlMenuButton href="javascript:;">
              <icon-horizontal-dots class="rotate-90 opacity-70" />
            </a>
            <div #dropdownPlaceholder *hlMenuItems>
              <app-message-portal #messagePortalComponent @toggleAnimation (portalAttached)="onPortalAttached()">
                <li>
                  <a href="javascript:;" *hlMenuItem="let menuItem" (click)="openModalForEdit(value)">
                    <icon-pencil-paper class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                    {{ "edit_quick_label" | translate }}
                  </a>
                </li>
                <li>
                  <a href="javascript:;" *hlMenuItem="let menuItem" (click)="handleDelete(value)">
                    <icon-trash-lines class="shrink-0 ltr:mr-2 rtl:ml-2" />
                    {{ "delete_quick_label" | translate }}
                  </a>
                </li>
              </app-message-portal>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-datatable>
  </div>
</div>

<ng-template #addCategoryModalTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl font-bold" *ngIf="!isEditing">{{ "office-branch.add_new_tax_category" | translate }}</div>
    <div class="!pb-5 text-xl font-bold" *ngIf="isEditing">{{ "tax_categories.edit_category" | translate }}</div>
    <app-tax-rates-modal [edit]="isEditing" [category]="editCategory" (updated)="closeModal()"></app-tax-rates-modal>
  </div>
</ng-template>
